import React, { Component } from 'react';
import { forwardRef } from 'react';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
//import MaterialTable from "material-table";
// Component styles
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import {getObjectiveAvailabilityResponse} from '../../../../../services/getObjectiveAvailabilityResponse'
import WindowModal from './WindowModal'
import WindowModalMonthDelete from './WindowModalMonthDelete'
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'  
import Replay from '@material-ui/icons/Replay';

moment.locale('es')

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    Replay: forwardRef((props, ref) => <Replay {...props} ref={ref} />)
}; 
class ControlMonthObjective extends Component {

    
    constructor(props) {
        super(props);
        var filterMonth=(Object.keys(props.data.data[0]).filter(i=>i.length>3&&i!=='kpi'))
        filterMonth.length=filterMonth.length-1
        filterMonth.reverse()
        var listDataMonth=[]

        const modificado = {} 
        props.data.monthHistoric.forEach(item=>{
            const key = Object.keys(item)[0]
            modificado[key] = item[key][0].modificado
        })

        filterMonth.map(ele=>{
            var newDictMonths={}
            newDictMonths["mes"]=ele
            props.data.data.map(elePerf=>{
                if(elePerf["kpi"]==='Perf 15 seg.'){
                    elePerf["kpi"]='perf'
                }
                if(elePerf["kpi"]==='Fuera de Sla'){
                    elePerf["kpi"]='fuera'
                }
                if(elePerf["kpi"]==='Indisponibilidad/Error'){
                    elePerf["kpi"]='error'
                }
                if(elePerf["kpi"]==='Tiempo de Respuesta'){
                    elePerf["kpi"]='tiempo'
                }
                newDictMonths[elePerf["kpi"]]=elePerf[ele]
            })
            listDataMonth.push(newDictMonths)
        })
        this.handleCloseControl= this.handleCloseControl.bind(this);
        this.handleControl= this.handleControl.bind(this);
        this.state = {
            dataObjective:props.data.showObjective,
            dialogOpen:false,
            dialogOpenDeleteMonth:false,
            value:0,
            data:listDataMonth,
            modificadoMonth : modificado,
            prevData:this.props.data,
            displayOther:false,
            row:null,
            event:null,
            perf:0,
            error:0,
            out:0,
            errorMsg:"",
            sendValue:0,
            row:"",
            event:"",
            step:props.data.step,
            performance:props.data.sla_p,
            load:false, 
        }
        
    }

    handleControl =(time)=>{
        const {prevData, data,modificadoMonth}=this.state
        //console.log("handlecontrol", time)
        let begin=moment(prevData.dateRange.selection.startDate).format("YYYY-MM-DD")
        let final=moment(prevData.dateRange.selection.endDate).add({'days':1}).format("YYYY-MM-DD")
        this.setState({
            load: true,  
        })
        getObjectiveAvailabilityResponse(prevData.user,begin, final,prevData.showObjective.objetivo_id, prevData.step.id_paso, prevData.sla_p, 29)
        .then( value => {
            //FILTRO POR LO QUE VIENE EN LA API
            var filterAPi=(value[0].historico.filter(i=>Object.keys(i)[0]===time)[0][time].map(({mes,modificado ,perf_error, perf_ok, perf_parcial, 
                promedio})=>({mes,modificado ,perf_error, perf_ok, perf_parcial, promedio}))[0])
            filterAPi["perf"]=filterAPi["perf_ok"]
            filterAPi["error"]=filterAPi["perf_error"]
            filterAPi["fuera"]=filterAPi["perf_parcial"]
            filterAPi["tiempo"]=filterAPi["promedio"]
            filterAPi["modificadoMonth"]=filterAPi["modificado"]
            delete filterAPi["perf_ok"]
            delete filterAPi["perf_error"]
            delete filterAPi["perf_parcial"]
            delete filterAPi["promedio"]
            // delete filterAPi["modificado"]
            
            //FILTRO DE ESTADO
            var dataState=data.filter(i=>i.mes===time)[0]
            //SE COLOCA ID EN NUEVO DICCIONARIO
            filterAPi["updateMonth"] = true
            filterAPi["tableData"]=dataState["tableData"]
            var newData = data.map(u => u.mes !== filterAPi.mes ? u : filterAPi);
            this.setState({
                data: newData,
                load:false  
            })
        })
    }

    handleCloseControl =(value)=>{
        this.setState({
            dialogOpen: false,  
            dialogOpenDeleteMonth : false
        })
    }

    handleBack =()=>{
        this.props.handleBackControl()
    }

    handleCloseModal = event => {   
        this.setState({
            dialogOpen: false,  
            dialogOpenDeleteMonth:false
        })
    };
    

    
    render() {
        const {classes}= this.props
        const {dialogOpen, value, data, displayOther,labelNum, prevData, errorMsg, row, event, step, performance, dataObjective, load,dialogOpenDeleteMonth, modificadoMonth}=this.state
        // console.log("data",data)
        //console.log(prevData.showObjective.nombre)
        if(load===true){
            return (
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                    >
                    <Typography
                        variant="caption"
                    >
                        <CircularProgress
                        variant="indeterminate"
        
                        size={12}
                        thickness={3}
                        
                        />
                        Cargando Informacion....
                    </Typography>
                </Grid>
              );
        }else{

            return(
                <Grid
                    container
                    spacing={1}
                >
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"left"}}
                    >
                        <Button onClick={this.handleBack}>
                            <ArrowBackIosIcon/>
                        </Button>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center"}}
                    >
                        <Typography variant="h4">{prevData.showObjective.nombre}-{step.nombre_paso}</Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center"}}
                    >
                        <Typography variant="h6">Performance: {performance} segs.</Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                    >
                        <MaterialTable
                            //style={{backgroundColor:"#656565"}}
                            icons={tableIcons}
                            columns={[
                                { title: "Mes", field: "mes", /*defaultGroupOrder: 0 */},
                                { title: "Perf 15 seg", field: "perf" },
                                { title: "Fuera de SLA (seg)", field: "fuera"/*, type: "numeric"*/ },
                                { title: "Indisponibilidad/Error(seg)", field: "error"/*, type: "numeric"*/},
                                { title: "Tiempo de Respuesta (seg)", field: "tiempo"/*, type: "numeric"*/},
                            ]}
                            data={data}
                            actions={[
                                 ()=>({
                                    // disabled :rowData.dia === lastDay,
                                    icon: Edit,
                                    tooltip : 'Editar Registros',
                                    onClick: (event,rowData) => {
                                    this.setState({dialogOpen: true, row:rowData, event:event});
                                  }
                                }),

                                rowData =>({     
                                    disabled: rowData.updateMonth?rowData.modificado != true  : !rowData.modificadoMonth && modificadoMonth[rowData.mes] == false,
                                    icon: Replay,
                                    tooltip : 'Restablecer Registros',
                                    onClick: (event,rowData) => {
                                        this.setState({dialogOpenDeleteMonth: true, row:rowData, event:event});
                                       }
                                })
                              ]}
                            title=" "
                            localization={{
                                /*grouping: {
                                    groupedBy: 'Agrupar por:',
                                    placeholder: 'Arrastre los encabezados aquí, para agrupar',
                                },*/
                                body: {
                                    emptyDataSourceMessage: 'No hay datos'
                                },
                                toolbar: {
                                    searchTooltip: 'Buscar',
                                    searchPlaceholder: 'Buscar'
                                },
                                pagination: {
                                    labelRowsSelect: 'Filas',
                                    labelDisplayedRows: ' {from}-{to} de {count}',
                                    firstTooltip: 'Pri. pág.',
                                    previousTooltip: 'Pág. previa',
                                    nextTooltip: 'Sig. pág.',
                                    lastTooltip: 'Últ. pág'
                                }
                            }}
                            options={{
                                grouping: false
                            }}
                        />
                        <Modal
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            open={dialogOpen}
                            onClose={this.handleCloseModal}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                
                            }}
                            disableAutoFocus={true}
                            disableEnforceFocus={true}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >                                    
                            <Fade in={dialogOpen}>
                                <WindowModal row={row}  handleCloseControl={this.handleCloseControl} handleControl={this.handleControl} dataObjective={dataObjective}/>
                            </Fade>
                        </Modal>
                        <Modal
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            open={dialogOpenDeleteMonth}
                            onClose={this.handleCloseModal}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                
                            }}
                            disableAutoFocus={true}
                            disableEnforceFocus={true}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >                                    
                            <Fade in={dialogOpenDeleteMonth}>
                                <WindowModalMonthDelete row={row}  handleCloseControl={this.handleCloseControl} handleControl={this.handleControl}
                                 dataObjective={dataObjective} prevData={prevData} dates={this.props.data.dateRange.selection}/>
                            </Fade>
                        </Modal>
                    </Grid>
                </Grid>
            )
        }
        
    }
}



//export default (Movistar);

export default compose(withStyles(styles))(ControlMonthObjective);



// WEBPACK FOOTER //
// ./src/layouts/components/content/Control/ControlMonthObjective/index.jsx